import { useEffect } from 'react'

/**
 * Helps detecting clicks outside of ref
 * @param {*} ref - Reference to node to use
 * @param {*} handler - Handler function to call when click outside is detected.
 * Preferably use useCallback for handler function to provide a stable reference through renders
 */
function useOnClickOutside(ref, handler) {
  useEffect(() => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return
        }
        handler(event)
      }
      document.addEventListener('mousedown', listener)
      document.addEventListener('touchstart', listener)
      return () => {
        document.removeEventListener('mousedown', listener)
        document.removeEventListener('touchstart', listener)
      }
    },
    [ref, handler],
  )
}

export default useOnClickOutside
